enum FormStatus {
	Pending = 'pending',
	Valid = 'valid',
	Invalid = 'invalid',
	Disabled = 'disabled',
	Hidden = 'hidden',
};

export default FormStatus;
